import { Attributes } from "../../Widgets/Attributes"

export const PersonalityTemplate = ({ valuesForm, lookForm, toneForm, attributesForm }) => {
    return (
        <div className="border-t">
            <p className="p-3 font-bold border-b text-xl">Personality</p>
            <div className="ml-16 border-l">
                <div>
                    <p className="p-3 font-bold border-b text-xl">Values</p>
                    <span className="font-bold pl-3 pt-3">Core Personality Values:</span>
                    <ul className="p-3 border-b">
                        {valuesForm?.personalityValues.map((el, index) => (
                            <li key={index}>{el.personalityValue}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="p-3 font-bold border-b text-xl">Look</p>
                    <span className="font-bold pl-3 pt-3">All Look and Feel Attributes:</span>
                    <ul className="p-3 border-dashed border-b">
                        {lookForm?.allLookAndFeelAttributes.map((el, index) => (
                            <li key={index}>{el.lookAndFeelAttribute}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Five Look and Feel Attributes:</span>
                    <ul className="p-3 border-dashed border-b">
                        {lookForm?.fiveLookAndFeelAttributes.map((el, index) => (
                            <li key={index}>{el.lookAndFeelAttribute}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Three Look and Feel Attributes:</span>
                    <ul className="p-3 border-dashed border-b">
                        {lookForm?.threeLookAndFeelAttributes.map((el, index) => (
                            <li key={index}>{el.lookAndFeelAttribute}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Companies That Look Like That:</span>
                    <ul className="p-3 border-dashed border-b">
                        {lookForm?.companiesThatLookLikeThat1.map((el, index) => (
                            <li key={index}>{el.company}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">People That Look Like That:</span>
                    <ul className="p-3 border-b">
                        {lookForm?.companiesThatLookLikeThat2.map((el, index) => (
                            <li key={index}>{el.company}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="p-3 font-bold border-b text-xl">Tone</p>
                    <span className="font-bold pl-3 pt-3">All Tone Attributes:</span>
                    <ul className="p-3 border-dashed border-b">
                        {toneForm?.allToneAttributes.map((el, index) => (
                            <li key={index}>{el.toneAttribute}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Five Tone Attributes:</span>
                    <ul className="p-3 border-dashed border-b">
                        {toneForm?.fiveToneAttributes.map((el, index) => (
                            <li key={index}>{el.toneAttribute}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Three Tone Attributes:</span>
                    <ul className="p-3 border-dashed border-b">
                        {toneForm?.threeToneAttributes.map((el, index) => (
                            <li key={index}>{el.toneAttribute}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Companies That Sound Like That:</span>
                    <ul className="p-3 border-dashed border-b">
                        {toneForm?.companiesThatSoundLikeThat.map((el, index) => (
                            <li key={index}>{el.companyThatSoundsLikeThat}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">People That Sound Like That:</span>
                    <ul className="p-3 border-b">
                        {toneForm?.peopleThatSoundLikeThat.map((el, index) => (
                            <li key={index}>{el.peopleThatSoundLikeThat}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="p-3 font-bold border-b text-xl">Attributes</p>
                    <ul className="p-3 flex flex-col gap-6">
                        {attributesForm?.personalityAttributes.map((el, index) => (
                            <Attributes
                                key={index}
                                leftAttribute={el.leftAttribute}
                                personalityAttribute={el.personalityAttribute}
                                rightAttribute={el.rightAttribute}
                            />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}